/**
 * EnterpriseAdminRouteGuard
 *
 * Protects the internal enterprise dashboard with the raw platform role.
 * The normalized frontend role collapses `Super Admin` and `Admin` to `ADMIN`,
 * so it is not sufficient for this route.
 */

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';

export interface EnterpriseAdminRouteGuardProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

export const EnterpriseAdminRouteGuard: React.FC<EnterpriseAdminRouteGuardProps> = ({
  children,
  fallbackPath = '/unauthorized',
}) => {
  const { user } = useAuthStore();

  const platformRole = user?.platformRole;
  const isEnterpriseAdmin = platformRole === 'Super Admin' || platformRole === 'Organisation Admin';

  if (!user || !isEnterpriseAdmin) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
